import * as Types from './types';
import { actionTypes } from './constants';
import * as ComponentTypes from '../types';

export const updateHistory = (data: {
    nextPageId?: string;
    bonuses: ComponentTypes.IBonusParsed[];
}): Types.IUpdateHistoryAction => ({
    type: actionTypes.UPDATE_HISTORY,
    payload: data
});

export const updateStatus = (status: string): Types.IUpdateStatusAction => ({
    type: actionTypes.UPDATE_STATUS,
    payload: status
});

export const toggleLoading = (isLoading: boolean): Types.IToggleLoadingAction => ({
    type: actionTypes.TOGGLE_LOADING,
    payload: isLoading
});

export const loadNextPage = (): Types.ILoadNextPageAction => ({
    type: actionTypes.LOAD_NEXT_PAGE
});

export const setError = ({ error }: { error: string }): Types.ISetErrorAction => ({
    type: actionTypes.SET_ERROR,
    payload: { error }
});

export const updatePeriod = (): Types.IUpdatePeriodAction => ({
    type: actionTypes.UPDATE_PERIOD
});
